export default __webpack_public_path__ + "static/media/welcome-bg4.135f3175.png";